import { getAxios } from 'api'

const userService = {
  fetchUser() {
    return getAxios().get('account/users/me/v2/')
  },
}

export default userService



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/services/user.js